The response from the `updateUploadedCandidateProfileDates` mutation.
